import React from 'react';
import { GradientTextAction } from 'src/common';
import { Variable } from 'src/api/types';
import { Scope } from '../types';
import { exportVariablesToCsv } from 'src/components/VariableCSVReader/util';
import { mpEvent, MPEvents } from 'src/utils/mixpanel';
import styled from 'styled-components';

const Div = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 16px;
`;

interface VariableActionsProps {
  originalVariables: Variable[];
  scope: Scope;
  onAddNewVariable: () => void;
  isModal?: boolean;
}

export const VariableActions: React.FC<VariableActionsProps> = ({
  originalVariables,
  scope,
  onAddNewVariable,
  isModal,
}) => {
  return (
    <Div>
      <GradientTextAction
        $underline
        weight={500}
        px={14}
        onClick={() => {
          onAddNewVariable();
          mpEvent(MPEvents.ButtonClick, {
            button: 'Add new variable',
            modal: isModal ? 'Variables modal' : undefined,
            tags: ['VARIABLES'],
          });
        }}
        data-cy="add-variable-btn"
      >
        Add new variable
      </GradientTextAction>
      <GradientTextAction
        $underline
        weight={500}
        px={14}
        onClick={() => {
          exportVariablesToCsv(originalVariables, scope);
          mpEvent(MPEvents.ButtonClick, {
            button: 'Export CSV',
            tags: ['VARIABLES'],
          });
        }}
      >
        Export CSV
      </GradientTextAction>
    </Div>
  );
};
